export enum MODELS_EXTENSIONS {
    'application/zip' = 'zip'
}
export const MODELS_MAX_SIZE = {
    label: '500MB',
    value: 500 * 1024 * 1024
};